import { UI_PRIMITIVE__tabs, UI_PRIMITIVE__tabs_list, UI_PRIMITIVE__tabs_trigger } from '@/components/ui/UI_PRIMITIVE__tabs';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { FN_IMAGE__get_available_tabs } from '@/utils/_methods/FN_IMAGE__get_available_tabs';
import { ENUM__page_generation_layout_images_edit_tab } from './ENUM__page_generation_layout_images_edit_tab';

export function G_BAR__layout_image_edit_tabs() {
  const dispatch = use_dispatch();

  const { g_image_edit__field, g_image_edit__tab } = use_slice_ui(['g_image_edit__field', 'g_image_edit__tab']);

  const available_tabs = FN_IMAGE__get_available_tabs(g_image_edit__field);

  /*
   * EVENTS
   */

  function onValueChange(value: string) {
    dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__tab', value, valid_values: Object.values(ENUM__page_generation_layout_images_edit_tab) }));
  }

  /*
   * HTML
   */
  let class_name_item = 'shrink-0 flex items-center justify-start h-full  text-[10px] leading-none py-0 overflow-hidden text-bar-foreground';

  if (g_image_edit__field.is_stub()) return null;

  return (
    <>
      <div className="flex-shrink-0 w-full h-6 overflow-auto flex flex-row items-center justify-start gap-2 bg-bar border-b border-component-border">
        <UI_PRIMITIVE__tabs
          defaultValue={g_image_edit__tab}
          value={g_image_edit__tab}
          orientation="horizontal"
          className="h-full w-full"
          {...{ onValueChange }}
        >
          <UI_PRIMITIVE__tabs_list className="flex flex-row h-full w-full items-stretch justify-start dark:bg-bar rounded-none">
            {available_tabs.map(tab => {
              const is_active = g_image_edit__tab === tab;
              return (
                <UI_PRIMITIVE__tabs_trigger key={tab} value={tab} className={`${class_name_item} ${tab == g_image_edit__tab ? '!bg-component' : 'opacity-50'}`}>
                  {tab}
                </UI_PRIMITIVE__tabs_trigger>
              );
            })}
          </UI_PRIMITIVE__tabs_list>
        </UI_PRIMITIVE__tabs>
      </div>
    </>
  );
}
